// Auto-generated by scripts/write-build-info.js — DO NOT EDIT.
// Regenerated on every build/deploy. Gitignored.
const BUILD_INFO = {
  "sha": "224b9cee8c8b67a2c44e3cfeea613ec556e0d382",
  "shaShort": "224b9ce",
  "branch": "main",
  "time": "2026-11-04T08:21:10.368Z"
};

module.exports = BUILD_INFO;
module.exports.default = BUILD_INFO;
